import { requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const getAllAreas = (user) => {
  return requestWithPromise(
    '/api/areas',
    HttpMethods.GET,
    null,
    user
  )
}
